import { useTranslations } from "@fenetech/translations";
import React from "react";
import { ListItem, ListItemIcon, Autocomplete, ListItemText, Grid, TextField } from "@mui/material";
import RectangleRoundedIcon from "@mui/icons-material/RectangleRounded";
import { ICADLayer } from "../../interfaces";
import { LayerTypeEnum } from "../../enums";
import { GlassLayerHelpers } from "../../GlassLayerHelpers";
import { useCADState, useCADActions } from "../../Context/CADContext";
import { GridLayerIcon } from "./GridLayerIcon";
import { GlassLayerIcon } from "./GlassLayerIcon";

interface GlassLayerSelectionProps {

}

function getLayerIcon(layer: ICADLayer): React.ReactNode {
    switch (layer.layerType) {
        case LayerTypeEnum.Grid:
            return <GridLayerIcon layer={layer} />;
        case LayerTypeEnum.Spacer:
            return <RectangleRoundedIcon style={{ stroke: "black", color: "silver", fontSize: 32, transform: "scale(.8)" }} />;
        default:
            return <GlassLayerIcon layer={layer} />;
    }
}

const GlassLayerSelection: React.FC<GlassLayerSelectionProps> = () => {
    const tm = useTranslations();
    const cadState = useCADState()
    const cadActions = useCADActions();
    const glassLayers = GlassLayerHelpers.GetAllGlassLayers(cadState.model, false);

    const onLayerChange = (glassLayer: ICADLayer) => {
        cadActions.setCurrentLayer(glassLayer.name)
        cadActions.clearUIState();
    }

    if (glassLayers.length <= 1) {
        return null;
    }

    return (
        <>
            <Grid container direction="row" spacing="1">
                <Autocomplete
                    fullWidth
                    autoComplete
                    disableClearable
                    autoSelect
                    selectOnFocus={false}
                    handleHomeEndKeys
                    value={cadState.currentLayer ?? undefined}
                    options={glassLayers}
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) => option.name === value.name}
                    disabled={cadState.operationEditor !== null || glassLayers.length === 1}
                    onChange={(_, value) => onLayerChange(value)}
                    renderOption={(props, option) => (
                        <ListItem
                            {...props}
                            style={{
                                paddingLeft: `${GlassLayerHelpers.GetGlassLayerVisualDepth(cadState.model, option.name) * 16}px`,
                                paddingTop: 0,
                                paddingBottom: 0,
                            }}

                        >
                            <ListItemIcon>
                                {
                                    getLayerIcon(option)
                                }

                            </ListItemIcon>
                            <ListItemText primary={option.name}

                                style={{ margin: 0, padding: 0 }}
                            />
                        </ListItem>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                            label={tm.Get("Glass Layer")}
                            inputProps={{
                                ...params.inputProps,
                                readOnly: true,
                                cursor: "pointer",

                            }}
                            InputProps={{
                                ...params.InputProps,
                                style: { cursor: "pointer" },
                                readOnly: true,
                                startAdornment: <>
                                    {cadState.currentLayer && getLayerIcon(cadState.currentLayer)}
                                </>
                            }}
                        />
                    )}
                />
            </Grid>
        </>

    )
}
export default GlassLayerSelection;
